export default __webpack_public_path__ + "static/it-hyderabad-1071f659116dd0adb21a15c52861a508.png";